export var ALL = 'all';
export var NO_CACHE = 'no-cache';
export var USE_CACHE = 'x-chegg-use-cache';
export var EVICT_CACHE = 'x-chegg-evict-cache';
export var APOLLO_GRAPHQL_CLIENT_NAME = 'apollographql-client-name';
export var APOLLO_STUDIO_EXPLORER = 'digitalPlatform';
export var CONTENTFUL_PREVIEW_ACCESS_TOKEN = 'x-chegg-contentful-preview-access-token';